import { render, staticRenderFns } from "./sos_vehicle_context.vue?vue&type=template&id=5d23175c&scoped=true&"
import script from "./sos_vehicle_context.vue?vue&type=script&lang=js&"
export * from "./sos_vehicle_context.vue?vue&type=script&lang=js&"
import style0 from "./sos_vehicle_context.vue?vue&type=style&index=0&id=5d23175c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23175c",
  null
  
)

export default component.exports